export default __webpack_public_path__ + "static/media/sos.df63997b.png";